import React, { useEffect, useState } from 'react'
import seqStore from '../../store/seqStore'

export default function KeyboardIcon() {
    const currentTrack = seqStore((state) => state.settings.currentTrack)

    const [fillColour, setFillColour] = useState('#FFB72C')

    useEffect(() =>{
        switch(currentTrack) {
            case 0:
                setFillColour('#FFB72C')
                break
            case 1:
                setFillColour('#FC4B4B')
                break
            case 2:
                setFillColour('#47BE61')
                break
            case 3:
                setFillColour('#1A8DF8')
                break
            default: setFillColour('#FFB72C')
        }
    }, [currentTrack])

    return (
        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="1.06714" width="6.92785" height="18.9329" rx="1.08188" fill={fillColour}/>
            <rect x="8.53601" y="1.06714" width="6.92785" height="18.9329" rx="1.08188" fill={fillColour}/>
            <rect x="17.0721" y="1.06714" width="6.92785" height="18.9329" rx="1.08188" fill={fillColour}/>
            <rect x="4.34619" width="6.92785" height="10.9843" rx="1.08188" fill="#1C1E21"/>
            <rect x="12.9592" width="6.92785" height="10.9843" rx="1.08188" fill="#1C1E21"/>
        </svg>



    )
}
